'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) { method = iterable[Symbol.asyncIterator]; if (method != null) return method.call(iterable); } if (Symbol.iterator) { method = iterable[Symbol.iterator]; if (method != null) return method.call(iterable); } } throw new TypeError("Object is not async iterable"); }

const multibase = require('multibase');

const {
  Buffer
} = require('buffer');

const log = require('debug')('ipfs-http-client:pubsub:subscribe');

const SubscriptionTracker = require('./subscription-tracker');

const configure = require('../lib/configure');

const toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure((api, options) => {
  const subsTracker = SubscriptionTracker.singleton();

  const publish = require('./publish')(options);

  return async (topic, handler, options = {}) => {
    options.signal = subsTracker.subscribe(topic, handler, options.signal);
    let res; // In Firefox, the initial call to fetch does not resolve until some data
    // is received. If this doesn't happen within 1 second send an empty message
    // to kickstart the process.

    const ffWorkaround = setTimeout(async () => {
      log("Publishing empty message to \"".concat(topic, "\" to resolve subscription request"));

      try {
        await publish(topic, Buffer.alloc(0), options);
      } catch (err) {
        log('Failed to publish empty message', err);
      }
    }, 1000);

    try {
      res = await api.post('pubsub/sub', {
        timeout: options.timeout,
        signal: options.signal,
        searchParams: toUrlSearchParams(_objectSpread({
          arg: topic
        }, options)),
        headers: options.headers
      });
    } catch (err) {
      // Initial subscribe fail, ensure we clean up
      subsTracker.unsubscribe(topic, handler);
      throw err;
    }

    clearTimeout(ffWorkaround);
    readMessages(res.ndjson(), {
      onMessage: handler,
      onEnd: () => subsTracker.unsubscribe(topic, handler),
      onError: options.onError
    });
  };
});

async function readMessages(msgStream, {
  onMessage,
  onEnd,
  onError
}) {
  onError = onError || log;

  try {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;

    var _iteratorError;

    try {
      for (var _iterator = _asyncIterator(msgStream), _step, _value; _step = await _iterator.next(), _iteratorNormalCompletion = _step.done, _value = await _step.value, !_iteratorNormalCompletion; _iteratorNormalCompletion = true) {
        const msg = _value;

        try {
          onMessage({
            from: multibase.encode('base58btc', Buffer.from(msg.from, 'base64')).toString().slice(1),
            data: Buffer.from(msg.data, 'base64'),
            seqno: Buffer.from(msg.seqno, 'base64'),
            topicIDs: msg.topicIDs
          });
        } catch (err) {
          err.message = "Failed to parse pubsub message: ".concat(err.message);
          onError(err, false, msg); // Not fatal
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          await _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } catch (err) {
    // FIXME: In testing with Chrome, err.type is undefined (should not be!)
    // Temporarily use the name property instead.
    if (err.type !== 'aborted' && err.name !== 'AbortError') {
      onError(err, true); // Fatal
    }
  } finally {
    onEnd();
  }
}